<template>
  <div v-loading="loading">
    <div class="header">
      <el-button
        type="primary"
        @click="$router.push({ name: 'FiscalRisksAdd' })"
        >Qo'shish</el-button
      >
    </div>
    <div class="notes">
      <div>
        Portalda hujjatlar eng oxirgi qo'shilgani birinchi bo'lib chiqadi.
        Tartibni keyinchalik o'zgartirib bo'lmaydi.
      </div>
      <div>
        O'zgarishlar portalda 5 daqiqagacha kechikib ko'rinishi mumkin
        (kesh).
      </div>
    </div>
    <el-table
      class="table-body"
      :data="tableData"
      border
      height="calc(100vh - 300px)"
    >
      <el-table-column type="index" label="T/r" />
      <el-table-column prop="title" label="Nomi">
        <template #default="scope">
          {{ scope.row.title || "—" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="images"
        class="img-column"
        label="Rasm"
      >
        <template #default="scope">
          <img
            v-if="scope.row.images[0]?.file_id"
            :src="baseUrl + scope.row.images[0]?.file_id"
            alt="Image"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="Yuklab olishlar" width="150">
        <template #default="scope">
          <el-tooltip
            content="Tahrirlashdan keyin qayta 0 dan boshlanadi"
            placement="top"
          >
            <span>{{ scope.row.attachments[0]?.downloads ?? 0 }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Yaratilgan sana" width="170">
        <template #default="scope">
          {{ $moment(scope.row.created_at).format("DD.MM.YYYY HH:mm") }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="Amallar" width="110">
        <template #default="scope">
          <div class="row-actions">
            <el-tooltip content="Tahrirlash" placement="top">
              <el-button
                type="primary"
                circle
                size="small"
                @click="
                  $router.push({
                    name: 'FiscalRisksEdit',
                    params: { id: scope.row.id },
                  })
                "
              >
                <img
                  alt="Tahrirlash"
                  class="action-icon"
                  src="@/assets/images/icons/edit.svg"
                />
              </el-button>
            </el-tooltip>
            <el-tooltip content="O'chirish" placement="top">
              <el-button
                type="danger"
                circle
                size="small"
                @click="deleteFiscalRisks(scope.row)"
              >
                <img
                  alt="O'chirish"
                  class="action-icon"
                  src="@/assets/images/icons/delete.svg"
                />
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
export default {
  name: "FiscalRisks",
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      limit: 20,
      totalCount: 0,
      baseUrl: process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/",
    };
  },
  methods: {
    getFiscalRisks() {
      this.loading = true;
      this.$http
        .get(`api/v1/posts/fiscal-risks`, {
          params: {
            cache: "off",
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.tableData = data.results;
          this.totalCount = data.count;
        })
        .catch(({ response }) => {
          ElNotification.error({
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteFiscalRisks(row) {
      ElMessageBox.confirm(
        `«${row.title || "—"}» hujjati o'chirilsinmi? Bu amalni bekor qilib bo'lmaydi.`,
        "Diqqat!",
        {
          confirmButtonText: "O'chirish",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`api/v1/posts/fiscal-risks/${row.id}`, {
              params: { cache: "off" },
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: "Hujjat o'chirildi",
              });
              if (
                this.tableData.length === 1 &&
                this.currentPage > 1
              ) {
                this.currentPage -= 1;
              }
              this.getFiscalRisks();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },

    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getFiscalRisks();
    },
    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getFiscalRisks();
    },
  },
  mounted() {
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
    this.getFiscalRisks();
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
.notes {
  margin-bottom: 10px;
  color: #909399;
  font-size: 0.8rem;
  line-height: 1.4;
}
.table-body {
  img {
    width: 80px;
  }
}

.row-actions {
  display: inline-flex;
  gap: 6px;
  justify-content: center;
}
.table-body .action-icon {
  width: 14px;
  height: 14px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
